/* eslint-disable */
/**
 * 注册全局组件
 */
// import ElementUI from 'element-ui'
//import FormDialog from './formDialog';
import Breadcrumb from './Breadcrumb';
import SingleTablePanel from './SingleTablePanel';
import Individuation from './Individuation';
import DialogImage from './DialogImage';
import DialogEdit from './DialogEdit';
import AlertDialogNew from './AlertDialogNew';
import DatePicker from './DatePicker';
import Upload from './Upload';

export default (Vue)=>{
  Vue.component('Breadcrumb',Breadcrumb);
  Vue.component('SingleTablePanel',SingleTablePanel);
  Vue.component('Individuation',Individuation);
  Vue.component('DialogImage',DialogImage);
  Vue.component('DialogEdit',DialogEdit);
  Vue.component('AlertDialogNew',AlertDialogNew);
  Vue.component('DatePicker',DatePicker);
  Vue.component('Upload',Upload);
}



// WEBPACK FOOTER //
// ./src/components/index.js